import { render, staticRenderFns } from "./MenuEgressos.vue?vue&type=template&id=596ad44a&scoped=true&lang=pug&"
import script from "./MenuEgressos.vue?vue&type=script&lang=js&"
export * from "./MenuEgressos.vue?vue&type=script&lang=js&"
import style0 from "./MenuEgressos.styl?vue&type=style&index=0&id=596ad44a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596ad44a",
  null
  
)

export default component.exports